// wetchat.js －－ 个人封装
import wx from 'weixin-js-sdk'; // 引入wxJS
import Cookies from 'js-cookie'
import {isWxBrowser} from '@/utils/commonUtils'

export function wxChatShare(param) {
    if (!isWxBrowser()){
        return;
    }
    const type = Cookies.get('type') || '0';
    const url = param.url
    window.axios.get("/wx/sdk",  {params: {type: type, url: url}}) // wechatConfig是获取微信配置相关信息的接口，此处根据个人项目写法而定，类似于this.$ajax
        .then (res => {
            if(res.code == 200) {
                // 接口返回配置信息
                wx.config({
                    debug: false,
                    appId: res.data.appId,
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名
                    jsApiList: [ // 用的方法都要加进来
                        'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ','saveImageToPhotosAlbum'
                    ]
                });
                wx.ready(function () {
                    //分享到朋友圈

                    wx.updateTimelineShareData({
                        title: param.title, // 分享标题
                        link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: param.imgUrl, // 分享图标
                        success: function () {
                            // 设置成功
                            console.log("分享到朋友圈成功返回的信息为:", res);
                            saveOpInfo(param)
                        }
                    })

                    wx.onMenuShareTimeline({
                        title: param.title, // 分享标题
                        link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: param.imgUrl, // 分享图标
                        success: function () {
                            // 用户点击了分享后执行的回调函数
                            saveOpInfo(param)
                        },
                    })

                    //分享给朋友

                    wx.updateAppMessageShareData({
                        title: param.title, // 分享标题
                        desc: param.desc, // 分享描述
                        link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: param.imgUrl, // 分享图标
                        success: function () {
                            // 设置成功
                            console.log("分享到朋友圈成功返回的信息为:", res);
                            saveOpInfo(param)
                        }
                    })
                    wx.onMenuShareAppMessage({
                        title: param.title, // 分享标题
                        desc: param.desc, // 分享描述
                        link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: param.imgUrl, // 分享图标
                        type: param.type, // 分享类型,music、video或link，不填默认为link
                        dataUrl: param.dataUrl, // 如果type是music或video，则要提供数据链接，默认为空
                        success: function () {
                            // 用户点击了分享后执行的回调函数
                            saveOpInfo(param)
                        }
                    });
                    wx.onMenuShareQQ({
                        title: param.title, // 分享标题
                        desc: param.desc, // 分享描述
                        link: param.link, // 分享链接
                        imgUrl: param.imgUrl, // 分享图标
                        success: function () {
                            saveOpInfo(param)
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                });
                wx.error(function (res) {
                    console.log('验证失败返回的信息:', res);
                });
            } else {
                console.log(res.data.message);
            }
        })
}


export function wxChatSaveImg(param) {
    if (!isWxBrowser()){
        return;
    }
    const type = Cookies.get('type') || '0';
    const url = param.url
    const imageUrl = param.imageUrl
    window.axios.get("/wx/sdk",  {params: {type: type, url: url}}) // wechatConfig是获取微信配置相关信息的接口，此处根据个人项目写法而定，类似于this.$ajax
        .then (res => {
            if(res.code == 200) {
                // 接口返回配置信息
                wx.config({
                    debug: false,
                    appId: res.data.appId,
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名
                    jsApiList: [ // 用的方法都要加进来
                        'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ','saveImageToPhotosAlbum'
                    ]
                });
                wx.ready(function () {
                    wx.saveImageToPhotosAlbum({
                        filePath: imageUrl, // 需要传递图片的文件路径，imageUrl 可以是 canvas.toDataURL 生成的 base64 URL
                        success(res) {
                            alert("图片已保存到相册！");
                        },
                        fail(err) {
                            console.error("保存失败：", err);
                        },
                    });
                });
                wx.error(function (res) {
                    console.log('验证失败返回的信息:', res);
                });
            } else {
                console.log(res.data.message);
            }
        })
}

function saveOpInfo(param){
    if(param['isProduct'] && param['isSave']){
        window.axios.post(`product/save-detail-opinfo?time=${Date.parse(new Date())}`, {
            productId: param['productId'],
            type: 1
        }).then((res) => {
            // let data = res.data;
            console.log("保存成功。")
        })
    }

}
/**
 * 小程序
 * @param param
 */
export function toWxxcx(param) {
    if (!isWxBrowser()){
        return;
    }
    let url = window.location.href.split('#')[0];// 当前页面url
    console.log(url)
    url = "https://test.h5.yibaojihua.com"
    window.axios.get("/wx/sdk",  {params: {type: 'xiaochengxu', url: url}}) // wechatConfig是获取微信配置相关信息的接口，此处根据个人项目写法而定，类似于this.$ajax
        .then (res => {
            if(res.code == 200) {
                // 接口返回配置信息
                wx.config({
                    debug: false,
                    appId: res.data.appId,
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名
                    jsApiList: [ // 用的方法都要加进来
                        'showMenuItems'
                    ],
                    openTagList:[
                        'wx-open-launch-weapp'
                    ],
                });
                wx.ready(function () {
                    console.log("小程序成功验证。")
                   /* wx.getPhoneNumber({
                        title: param.title, // 分享标题
                        desc: param.desc, // 分享描述
                        link: param.link, // 分享链接
                        imgUrl: param.imgUrl, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });*/
                });
                wx.error(function (res) {
                    console.log('小程序验证失败返回的信息:', res);
                });
            } else {
                console.log(res.data.message);
            }
        })
}
